const normalizeToArray = (value) => {
  if (!Array.isArray(value)) {
    return [value];
  } else {
    return value;
  }
};

export default normalizeToArray;
